import React from "react";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import LoginPage from "./pages/LoginPage";
import HomeLayout from "./layouts/HomeLayout";
import UsersPage from "./pages/UsersPage";
import { getBasicAuth } from "./services/authStorage";
import HomeIndexRedirect from "./pages/HomeIndexRedirect";
import EventsPage from "./pages/EventsPage";
import CeremoniesPage from "./pages/CeremoniesPage";
import GuestsPage from "./pages/GuestsPage";
import RsvpPage from "./pages/RsvpPage";
import RsvpSummaryPage from "./pages/RsvpSummaryPage";
import InvitationLogsPage from "./pages/InvitationLogsPage";


function ProtectedRoute({ children }: { children: React.ReactNode }) {
  const isAuthed = !!getBasicAuth();
  return isAuthed ? <>{children}</> : <Navigate to="/" replace />;
}

function App() {
  return (
    <BrowserRouter>
      <Routes>
        <Route path="/" element={<LoginPage />} />

        <Route
          path="/home"
          element={
            <ProtectedRoute>
              <HomeLayout />
            </ProtectedRoute>
          }
        >
          {/* Página por defecto dentro del home */}
          <Route index element={<HomeIndexRedirect />} />

          {/* Módulos */}
          <Route path="usuarios" element={<UsersPage />} />
          <Route path="eventos" element={<EventsPage />} />
          <Route path="rsvp" element={<RsvpPage />} />
          <Route path="rsvp/eventos/:eventoId/resumen" element={<RsvpSummaryPage />} />
          <Route path="rsvp/eventos/:eventoId/invitaciones-enviadas" element={<InvitationLogsPage />} />
          <Route path="eventos/:eventoId/ceremonias" element={<CeremoniesPage />} />
          <Route path="eventos/:eventoId/invitados" element={<GuestsPage />} />

          {/* Luego agregaremos: eventos, ceremonias, proveedores, etc */}
        </Route>

        <Route path="*" element={<Navigate to="/" replace />} />
      </Routes>
    </BrowserRouter>
  );
}

export default App;
